// extracted by mini-css-extract-plugin
module.exports = {"badgeOuter":"_3JmpE","text":"_2iOrI","discount":"_1jgbL","new":"_1tp87","sold":"_3D9S0","reserved":"_1fAU3","viewed":"_3VV7N","newStock":"_1URC9"};